import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges, input, output } from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { filter, map, Subscription, tap } from 'rxjs';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-single-select-prop-filter[formName][values]',
    template: `
    <form [formGroup]="formGroup()">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ formName() }}</mat-label>
        <mat-select [formControlName]="formName()">
          @for (value of values(); track value) {
            <mat-option [value]="value">{{
              value
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
    `,
    styles: [],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption]
})
export class SingleSelectPropFilterComponent implements OnInit, OnDestroy {
  readonly formName = input<any>();

  readonly formGroup = input.required<UntypedFormGroup>();

  readonly values = input<any>([]);

  readonly changes = output<any>();

  private sub!: Subscription | undefined;

  constructor() {}

  ngOnInit(): void {
    const valuesChangeSub = this.formGroup()
      .get(this.formName())?.valueChanges.pipe( 
        map(value => {
          const val = typeof value === 'string' ? `"${value}"` : value;
          if(val === null) {
            return null
          }
          return {[this.formName()]: val}
        }),
        filter(predicate => predicate !== null),
        tap(predicate => this.changes.emit(predicate))
      )
      .subscribe();

    this.sub = valuesChangeSub;
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe()
  }
}
